import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, Typography, useTheme } from '@material-ui/core'
import { Delete, Edit } from '@material-ui/icons'
import React, { useRef } from 'react'
import CloseIcon from '@material-ui/icons/Close';
import { Field, Form, Formik } from 'formik';
import { DatePicker } from 'formik-material-ui-pickers';
import * as Yup from "yup";
import { TextField } from 'formik-material-ui';
import { useAssetUpdate } from '../../../intake/intakeQueries';
import { toast } from 'react-toastify';
import { useFetchContext } from '../../../common/FetchContext';
import { usePostFile } from '../../../common/services/fileServices';
import { useQueryClient } from 'react-query';



export const CalibrationEdit = ({ data }: any) => {
    const [open, setOpen] = React.useState(false);
    const queryClient = useQueryClient();

    const theme = useTheme();
    const { authAxios } = useFetchContext();
    const handleClose = () => {
        setOpen(!open);
    };
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [files, setFiles] = React.useState([]);
    const handleFileUpload = async (item: any) => {
        console.log(item)
        fileInputRef.current?.click()
    };
    const handleFilePicked = (event: React.ChangeEvent<HTMLInputElement>) => {
        const uploadedFiles = event.target.files;
        if (uploadedFiles) {
            setFiles(uploadedFiles as any);
        }

    };

    const { mutateAsync: mutateAsset } = useAssetUpdate()
    const { mutateAsync: mutatePostFile } = usePostFile();
    return (
        <>
            {/* <Button
                color='primary'
                onClick={handleClose}
                startIcon={<Edit />}
            >
            </Button> */}
            <Button
                color='primary'
                onClick={() => setOpen(true)}
                startIcon={<Edit />}
            />
            <Dialog
                open={open}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullWidth={false}>
                <DialogTitle >

                    <div>
                        <Box display="flex" alignItems="center">
                            <Box flexGrow={1} >{"Update Calibration Details"}</Box>
                            <Box>
                                <IconButton onClick={handleClose}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>

                        </Box>
                        <Typography color='primary'>LAST UPDATE DETAILS</Typography>

                    </div>
                </DialogTitle>
                <DialogContent>
                    <Divider variant="fullWidth" />
                    <Container>
                        <Grid

                            container
                            direction="row"
                            justify="space-between"
                            alignItems="center"
                            spacing={4}
                            style={{ marginTop: 32 }}
                        >
                            <Grid item xs={12}>
                                <div>
                                    <Typography variant="subtitle1" color="secondary">
                                        Asset Id       : {data.asset_number}
                                    </Typography>
                                </div>

                                <div>
                                    <Typography variant="subtitle1" color="secondary">
                                        Asset Name      : {data.asset_name}
                                    </Typography>
                                </div>
                                <div>
                                    <Typography variant="subtitle1" color="secondary">
                                        Asset Type       : {data.asset_type_name}
                                    </Typography>


                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <Formik
                                    initialValues={{
                                        id: data.id || "",
                                        last_calibration_date: data.last_calibrated_date ,
                                        Schedule_for_calibration: data.schedule_for_calibration ,
                                        next_calibration_date: data.next_calibration_date ,
                                        Days_since_calibrated: data.days_since_calibrated ,
                                        Days_next_calibration: data.days_to_next_calibration ,
                                    }}
                                    validationSchema={Yup.object({
                                        last_calibration_date: Yup.date().required("This field is required"),
                                        Schedule_for_calibration: Yup.string().required("This field is required")
                                    })}
                                    onSubmit={async (values, { setSubmitting }) => {
                                        // setSubmitting(false);
                                        // setOpen(false);
                                        console.log("Form values", JSON.stringify(values));

                                        try {
                                            if (files.length > 0) {
                                                for (let file of files) {
                                                    const postedFile = await mutatePostFile({ authAxios, file });
                                                    await mutateAsset({
                                                        authAxios,
                                                        id: data.id,
                                                        last_calibration_date: values.last_calibration_date,
                                                        schedule_for_calibration: values.Schedule_for_calibration,
                                                        azurefile: postedFile.url,
                                                    });
                                                }
                                            } else {
                                                await mutateAsset({
                                                    authAxios,
                                                    id: data.id,
                                                    last_calibration_date: values.last_calibration_date,
                                                    schedule_for_calibration: values.Schedule_for_calibration,
                                                    // next_calibration_date: data.next_calibration_date,
                                                    // Days_since_calibrated: data.days_since_calibrated,
                                                    // Days_next_calibration: data.days_to_next_calibration,

                                                });
                                            }

                                            toast.success("Asset successfully updated")
                                            setSubmitting(false);
                                            queryClient.invalidateQueries(["assetsCalibration"]);
                                            handleClose();
                                        } catch (e) {
                                            toast.error(`Error updating: ${e}`);
                                        }
                                    }}
                                >
                                    {({ errors, touched, submitForm }) => (
                                        <Form>

                                            <Grid

                                                container
                                                // direction="row"
                                                justify="space-between"
                                                alignItems="center"
                                                spacing={4}
                                            // style={{ marginTop: 32 }}
                                            >
                                                <Grid item xs={12} >
                                                    <Field
                                                        id="last_calibration_date"
                                                        name="last_calibration_date"
                                                        component={DatePicker}
                                                        format="YYYY-MM-DD"
                                                        style={{ marginBottom: 32, marginRight: 32 }}
                                                        label="Last calibrated date"
                                                        inputVariant="outlined"
                                                    />
                                                    <Field
                                                        style={{ marginBottom: 32 }}
                                                        id="Schedule_for_calibration"
                                                        name="Schedule_for_calibration"
                                                        component={TextField}
                                                        label="Schedule for calibration"
                                                        inputVariant="standard"
                                                        fullwidth
                                                    />
                                                    <Field
                                                        id="next_calibration_date"
                                                        name="next_calibration_date"
                                                        component={DatePicker}
                                                        format="YYYY-MM-DD"
                                                        style={{ marginBottom: 32, marginRight: 32 }}
                                                        label="next calibrated date"
                                                        inputVariant="outlined"
                                                        disabled
                                                    />
                                                    <Field
                                                        style={{ marginBottom: 32, marginLeft: 10 }}
                                                        id="Days_since_calibrated"
                                                        name="Days_since_calibrated"
                                                        component={TextField}
                                                        label="Days since calibrated"
                                                        inputVariant="standard"
                                                        disabled

                                                    />
                                                    <Field
                                                        style={{ marginBottom: 32 }}
                                                        id="Days_next_calibration"
                                                        name="Days_next_calibration"
                                                        component={TextField}
                                                        label="Days to next calibration"
                                                        inputVariant="standard"
                                                        disabled

                                                    />

                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="h5" color="primary" >Upload Calibration Report <img onClick={handleFileUpload} src="/file_upload.svg" alt="Custom Icon" width="30" height="30" /> </Typography>
                                                </Grid>
                                                <Grid item xs={6}>

                                                    <input
                                                        ref={fileInputRef}
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        accept="image/*,.pdf"
                                                        onChange={handleFilePicked}
                                                    />
                                                    {files.length != 0 && <div style={{ position: "relative", display: "inline-block" }}>
                                                        <img src="/file_icon.png" alt="Custom Icon" height={200} width={200} />
                                                        <IconButton
                                                            style={{
                                                                position: "absolute",
                                                                top: "5px",
                                                                right: "5px",
                                                                background: "lightgray",
                                                                color: "black",
                                                                border: "none",
                                                                borderRadius: "50%",
                                                                width: "40px",
                                                                height: "40px",
                                                            }}
                                                            onClick={() => setFiles([])}
                                                        >
                                                            <Delete></Delete></IconButton>
                                                    </div>}
                                                </Grid>
                                                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <Button

                                                        variant="contained"
                                                        color="primary"
                                                        onClick={submitForm}
                                                    >
                                                        update
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Form>
                                    )}
                                </Formik>
                            </Grid>

                        </Grid>
                    </Container>


                </DialogContent>
                <DialogActions>
                </DialogActions>
            </Dialog>
        </>
    )
}



